import { ChangeEvent, useCallback, useState } from 'react'
import TextField from '~components/ui/text-input/text-field'
import { NumPerDayProps } from '~containers/app/ask-a-vet/types'

const NumPerDayOptions = ({ setValue, placeholder }: NumPerDayProps) => {
  const [count, setCount] = useState('')
  const onNumberPerDayValueChange = useCallback(
    (newValue: string) => {
      const isNumber = !isNaN(Number(newValue))

      if (!isNumber) {
        return
      }

      if (newValue.length >= 0) {
        setCount(newValue)
      } else {
        setCount('')
      }

      setValue({ value: Number(newValue) })
    },
    [setValue]
  )

  const onChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onNumberPerDayValueChange(event.target.value)
    },
    [onNumberPerDayValueChange]
  )

  return (
    <div className="flex w-full flex-1 gap-2">
      <div className="flex-1">
        <TextField
          value={count}
          onChange={onChange}
          className="h-[58px]"
          pattern="[0-9]*"
          type="tel"
          placeholder={placeholder}
          autoFocus
        />
      </div>
      <p className="text-body-large p-4 text-gray-700">per day</p>
    </div>
  )
}

export default NumPerDayOptions
